import days from '@anm/constants/days';
import getNextSundayDate from '@anm/helpers/date/getNextSundayDate';

const getCalendarFetchDates = () => {
  const week2 = getNextSundayDate(Date.now());

  const week1date = new Date(week2);
  week1date.setDate(week1date.getDate() - days.length);

  const week1 = getNextSundayDate(week1date.getTime());

  const week2date = new Date(week2);
  week2date.setDate(week2date.getDate() + days.length);

  const week3 = getNextSundayDate(week2date.getTime());

  return [week1, week2, week3] as const;
};

export default getCalendarFetchDates;
